import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TratamentoAuxiliarService {
    constructor(
        private apiService: ApiService
    ) {}

    post(form) : Observable<any> {
        return this.apiService.post('/tratamento-auxiliar', form)
    }
    
    getAll( idTratamento ): Observable<any> {
        let url : string = `/tratamento-auxiliar`
        return this.apiService.get(url, idTratamento)
    }

    get(id: string): Observable<any> {
        let url : string = `/tratamento-auxiliar/${id}`
        return this.apiService.get(url)
    }

    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/tratamento-auxiliar/'+id, form)
    }

    delete(id) {
        return this.apiService.delete('/tratamento-auxiliar/'+id)
    }

}